import { isPhone } from 'base/utils/client';
import { IBannerConfig } from 'mod/featureV2/interface/banner';

type IProps = {
    config: {
        sideSpace?: boolean;
        fullScreen?: boolean;
        type?: IBannerConfig['type'];
    };
    children: React.ReactNode;
};

export const FeatureWrapper: React.FC<IProps> = ({ config, children }) => {
    const {
        sideSpace = false,
        fullScreen = false,
    } = config;
    const sideSpaceChild = sideSpace ? <div className={'site-space'}>{children}</div> : <>{children}</>;
    const wrapperElem = fullScreen || isPhone ? sideSpaceChild : <div className="g-wrapper">{sideSpaceChild}</div>;
    return config.type === 'carousel' ? <div className={'w-full overflow'}>{wrapperElem}</div> : wrapperElem;
};